import { useRef } from "react";

import { 
  Box,
  Flex,
  Heading,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  Portal,
  Spacer,
  Text,
  useBreakpointValue,
  useDisclosure,
  useOutsideClick
} from "@chakra-ui/react";

import "react-big-calendar/lib/css/react-big-calendar.css";

export const CustomEvent = ({ event }) => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  const popoverRef = useRef(null)
  useOutsideClick({
    ref: popoverRef,
    handler: onClose,
  })

  const isMobile = useBreakpointValue(
    {
      "base": ()=> true,
      "xl": ()=>  false
    }
  );  

  const {setupId, setupName, slotStart, slotEnd, teamName, captainName, member2Name, member3Name, nonSetEventName, isSideEvent, showFreePlay} = event.title;

  const SetupTriggerDisplay = () => {
    if (
      setupId && ("" + setupId)?.length > 0 && 
      setupName && setupName?.length > 0
    ) {
      if (isMobile()) {
        return(
          <>
            <Text mb={4}>{setupId}:</Text>
          </>
        );
      }
      return (
        <>
          <Text mb={8}>{setupId} - {setupName}:</Text>
        </>

      )
    }
    return([]);
  }

  const PlayerTriggerDisplay = () => {
    if (!nonSetEventName) {
      if (teamName && teamName?.length > 0) {
        const teamNameDisplay = <Text color="#ffff86" filter="drop-shadow(0px 0px 4px #000000)">{teamName}</Text>;

        const captainNameDisplay = captainName && captainName?.length > 0
          ? <Text color="#ffffff" filter="drop-shadow(0px 0px 4px #000000)">{captainName}</Text>
          : <></>;

        const member2NameDisplay = member2Name && member2Name?.length > 0
          ? <Text color="#ffffff" filter="drop-shadow(0px 0px 4px #000000)">{member2Name}</Text>
          : <></>;          
          
        const member3NameDisplay = member3Name && member3Name?.length > 0
          ? <Text color="#ffffff" filter="drop-shadow(0px 0px 4px #000000)">{member3Name}</Text>
          : <></>;     

        return(
          <>
            {teamNameDisplay}
            {captainNameDisplay}
            {member2NameDisplay}
            {member3NameDisplay}
          </>

        );
      }
      return (
        <Text>Free</Text>
      )
    }
    return([]);
  }

  const BackgroundEventTriggerDisplay = () => {
    if (nonSetEventName && nonSetEventName?.length > 0) {
      return (
        <>
          <Heading size="sm" color={isSideEvent ? "#ff8e61" : "initial"} filter={isSideEvent ? "drop-shadow(0px 0px 4px #000000)" : "initial"}>{nonSetEventName}</Heading>
          {showFreePlay && (
            <Text>Free play</Text>
          )}
        </>
      );
    }
  }

  const SetupPopoverDisplay = () => {
    if (
      setupId && ("" + setupId)?.length > 0 && 
      setupName && setupName?.length > 0
    ) {
      return (
        <>
          <Heading size="sm">Setup {setupId}:</Heading>
          <Text>{setupName}</Text>
          <Text mb={4}>{slotStart} - {slotEnd}</Text>
        </>
      );
    }
    return ([]);
  }

  const PlayerPopoverNameDisplay = () => {
    if (!nonSetEventName) {
      if (teamName && teamName?.length > 0) {
        const teamNameDisplay = <Heading size="sm" color="#ffff86" filter="drop-shadow(0px 0px 4px #000000)">{teamName}</Heading>;

        const captainNameDisplay = captainName && captainName?.length > 0
          ? <Text color="#ffffff" filter="drop-shadow(0px 0px 4px #000000)">{captainName}</Text>
          : <></>;

        const member2NameDisplay = member2Name && member2Name?.length > 0
          ? <Text color="#ffffff" filter="drop-shadow(0px 0px 4px #000000)">{member2Name}</Text>
          : <></>;          
          
        const member3NameDisplay = member3Name && member3Name?.length > 0
          ? <Text color="#ffffff" filter="drop-shadow(0px 0px 4px #000000)">{member3Name}</Text>
          : <></>;     

        return (
          <>
            {teamNameDisplay}
            {captainNameDisplay}
            {member2NameDisplay}
            {member3NameDisplay}
          </>
        );
      }
      return(
        <><Text>Slot Available</Text></>
      )
    }
    return([]);
  };

  const BackgroundEventPopoverDisplay = () => {
    if (nonSetEventName && nonSetEventName?.length > 0) {
      return (
        <>
          <Heading size="sm" mb={4} color={isSideEvent ? "#ff8e61" : "initial"} filter={isSideEvent ? "drop-shadow(0px 0px 4px #000000)" : "initial"}>{nonSetEventName}</Heading>
          <Text mb={4}>{slotStart} - {slotEnd}</Text>
          {showFreePlay && (
            <Text>Free play</Text>
          )}
        </>
      );
    }
  }

  // it didn't like it when I tried to do the custom-event thing as a distinct component for whatever reason
  // (so don't do that)

  return(
    <Popover trigger={isMobile() ? "click" : "hover"}>
        <PopoverTrigger>
          <Box width="100%" height="100%" className="custom-event" style={event.style} >
            <SetupTriggerDisplay/>
            <PlayerTriggerDisplay/>
            <BackgroundEventTriggerDisplay/>
          </Box>
        </PopoverTrigger>
        <Portal>
          <PopoverContent>
              <PopoverArrow/>
              <PopoverBody>
                <SetupPopoverDisplay/>
                <Flex gap="15px" alignItems="anchor-center">
                  <PlayerPopoverNameDisplay/>
                  <Spacer/>
                </Flex>
                <BackgroundEventPopoverDisplay/>
              </PopoverBody>
          </PopoverContent>
        </Portal>
    </Popover>
  );
};